/*    
<summary>
  This functional component "AddOptionMenu" defines the props like initial values and functions for the child form component.
  Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import userTypeEnum from "../../../constants/enums/user-type-enum";
import { useStore } from "../../../contexts/store-provider";
import {
  getStoreIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../../helpers/localstorage-helper";
import AdvanceSearchCustomerForm from "../forms/advance-search-customer-form";
// import AdvanceSearchModal from "../forms/advance-search-form";

interface IProps {
  submitHandler: (values: any) => void;
  modalClosed: () => void;
}

const AdvanceSearchCustomer = (props: IProps) => {
  const {
    masterManagementStore,
    customerManagementStore,
    agreementManagementStore
  } = useStore();
  const {
    GetAllAgreementOptionService,
    getAllAgreementOptions,
    resetagreementOptionsState,
    allAgreements,
    agreementOptionsState
  } = agreementManagementStore;
  const {
    inProgress,
    GetAllCustomerListService,
    getAllCustomer,
    allCustomerState,
    resetAllCustomerList,
    resetDeleteCustomer,
    advanceSearchValues,
    advanceSearchState
  } = customerManagementStore;
  const {
    GetAllMotivationService,
    getAllMotivationOptions,
    GetStoreMotivationByStoreId,
    getMotivationInStoreOptions,
  } = masterManagementStore;

  const storeId = getStoreIdFromLocalStorage();
  const userType = getUserTypeFromLocalStorage();
  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (userType === userTypeEnum[userTypeEnum.Store]) {
      if (storeId > 0) {
        GetStoreMotivationByStoreId(storeId);
      }
    } else {
      GetAllMotivationService();
    }
    GetAllAgreementOptionService();
    GetAllCustomerListService();
  }, []);


  /**
   * This function adds the customer when "Id < 0" and updates the Existing customer when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: any) => {
    props.submitHandler(values);
  };


  /**
   * This function closes the pop up modal and reset getcustomerdetails, addUpdate treatement observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetAllCustomerList();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <AdvanceSearchCustomerForm
        initialValues={advanceSearchValues}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        motivationOptions={
          userType === userTypeEnum[userTypeEnum.Store]
            ? getMotivationInStoreOptions
            : getAllMotivationOptions
        }
        agreementOptions={getAllAgreementOptions}
        getDataLoading={
          allCustomerState.inProgress ||
          agreementOptionsState.inProgress
        }
        allCustomerList={getAllCustomer}
        actionLoading={advanceSearchState.inProgress}
      />
    </React.Fragment>
  );
};

export default observer(AdvanceSearchCustomer);
